export default [
    {
        path: "/",
        redirect: "/KbbScreenNew",
    }, {
        path: "/KbbScreenNew",
        name: "KbbScreenNew",
        component: () => import("@/views/KbbScreenNew.vue"),
    },
    {
        path: "/Question",
        name: "Question",
        component: () => import("@/views/Question.vue"),
    }, {
        path: "/AnswerDetails",
        name: "AnswerDetails",
        component: () => import("@/views/AnswerDetails.vue"),
    }, {
        path: "/Answer",
        name: "Answer",
        component: () => import("@/views/Answer.vue"),
    }, {
        path: "/KbbScreenNone",
        name: "KbbScreen",
        component: () => import("@/views/Kbb-Screen.vue"),
    },
]
